 import React, { useEffect, useState, useRef, useCallback} from 'react';
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import server from 'server/serverController2';
import chatController from 'server/chatController';
import ChatItemList from 'components/presenters/chat/ChatItemList';
import BottomTextArea from 'components/containers/input/BottomTextArea';
import qs from 'qs';
import useMutationObservable from 'hooks/common/useMutationObservable';
import downArrowIcon from 'images/arrow_down-14x8.png';
import CenterModal from 'components/presenters/modal/CenterModal';

export default function MatchingChatRoom({roomInfo, onJoinRoom}) {
  const history = useHistory();
  const userInfo = useSelector((state) => {
    return state.userInfo;
  }); 
  
  const chatScrollRef = useRef(null);
  const [triggerMoveBottom, setTriggerMoveBottom] = useState(false);
  const [chatList, setChatList] = useState([]);
  const [receivedChatItem, setReceivedChatItem] = useState(null);
  const [lastPosNo, setLastPosNo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isEnd, setIsEnd] = useState(false);
  const [isScrollMutated, setIsScrollMutated] = useState(false);
  const [bottomFormHeight, setBottomFormHeight] = useState(70);

  const [newMsgExist, setNewMsgExist] = useState(false);

  //Center Modal State
  const [initCenterModal, setInitCenterModal] = useState(false);
  const [centerModalVisible, setCenterModalVisible] = useState(false);
  const [centerModalDataList, setCenterModalDataList] = useState({});
  const [onModalComplete, setOnModalComplete] = useState(null);
  const [onModalCancel, setOnModalCancel] = useState(null);

  useMutationObservable(chatScrollRef.current, useCallback(
    (mutationList) => {
      setIsScrollMutated(true)
    },
    []
  ))

  //Init Center Modal State
  useEffect(()=>{
    if(initCenterModal === true)
    {
      setCenterModalVisible(false);
      setCenterModalDataList({})
      setOnModalComplete(null);
      setOnModalCancel(null);
      setInitCenterModal(false);
    }
  }, [initCenterModal])

  useEffect(()=>{
    if(isScrollMutated)
    {
      if(triggerMoveBottom)
      {
        moveToBottom();  
      }
    }
    setIsScrollMutated(false);
  },[isScrollMutated]);

  //init socket
  useEffect(()=>{
    const initSocketConnection = async () => {
      let roomObj = {};
      roomObj['room_no'] = roomInfo.no;
      roomObj['type'] = 'matching_chat';
      roomObj['on_received'] = onMsgReceived;
      await chatController.setMatchingChatConnection(roomObj);
    }

    const joinMatchingRoom = () => {
      return new Promise(async (resolve, reject) => {
        try
        {
          let roomNo = roomInfo['no'];
          server.postRequestData(`matching/rooms/${roomNo}/members`, {},(res)=>{
            if(res.success !== 1)
            {
              const errData = res.error.res_data;
              if(errData['detail_code'] === 'EXCEEDED_MAX_CAPACITY')
              {

                setCenterModalVisible(true);
                setCenterModalDataList({description:"정원을 초과하였습니다."});
                setOnModalComplete(()=>()=>{
                  setInitCenterModal(true);
                  history.replace('/matching');
                })
              }
              else
              {
                setCenterModalVisible(true);
                setCenterModalDataList({description:"참여에 실패하였습니다."});
                setOnModalComplete(()=>()=>{
                  setInitCenterModal(true);
                  history.replace('/matching');
                })
              }
              return;
            } 
            if(onJoinRoom) onJoinRoom();
            resolve(true);
          });
        }
        catch(err)
        {
            reject(err);
        }
      });
    }

    const initSocketData = async () => {
      if(roomInfo['is_member'] !== true)
      {
        let result = await joinMatchingRoom();
        if(result === true)
        {
          initSocketConnection();
          loadChatList();
        }
      }
      else
      {
        initSocketConnection();
        loadChatList();
      }
    }

    if(roomInfo)
    {
         initSocketData();
    }
    return function cleanUp() {
      chatController.disconnectConnection();
    }
  },[roomInfo]);


  useEffect(()=>{
    if(receivedChatItem!== null)
    {
      setChatList([...chatList, receivedChatItem]);
      setReceivedChatItem(null);
    }
  },[receivedChatItem])

  const loadChatList = ()=>{
    if(roomInfo && isLoading !== true && isEnd !== true)
    {
      setIsLoading(true);
      let queryString = qs.stringify({order_by: "no",limit:50, order: "desc", last_pos_no: lastPosNo})
      server.getRequestData(`matching/rooms/${roomInfo.no}/chats?${queryString}`,(res)=>{
        if(res.success === 0)
        {
          return;
        }
        if(chatList.length === 0)
        {
          setTriggerMoveBottom(true);
        }
        let jsonData = res.data;
        let receivedItems = jsonData['chats'];
        if(receivedItems.length > 0)
        {
          receivedItems = receivedItems.reverse()
          setLastPosNo(receivedItems[0]['no'])
          setChatList([...receivedItems,...chatList ])
        }
        else
        {
          setIsEnd(true);
        }
        setIsLoading(false);
      })
    }
  }

  const onMsgReceived = (data) => {
    let chatItem = data['chat_item'];
    if(chatItem)
    {
      setReceivedChatItem(chatItem);
      if(chatScrollRef?.current 
        && chatScrollRef.current.scrollHeight > (chatScrollRef.current.scrollTop + chatScrollRef.current.clientHeight + 300) 
        && parseInt(userInfo['id']) !== parseInt(chatItem['user_no']))
      {
        setNewMsgExist(true);  
      }
      else
      {
        setTriggerMoveBottom(true);
      }
    }
  }


  const handleSubmit = (value) =>{
    if(value.trim().length > 0)
    {
      let form = {
        room_no : roomInfo.no,
        content : value
      }
      chatController.sendMatchingChatMsg(form);
    }
  }

  const handleFormHeightChange = (height)=>{
    setBottomFormHeight(height);
  }

  const handleScroll = (e)=>{
    if(chatScrollRef?.current?.scrollTop <  200 && isLoading === false)
    {
      loadChatList();
    }
    if(chatScrollRef.current.scrollHeight === chatScrollRef.current.scrollTop + chatScrollRef.current.clientHeight) 
    {
      setNewMsgExist(false);
    }
  }

  const moveToBottom = ()=>{
    chatScrollRef.current.scrollTop = chatScrollRef.current.scrollHeight;
    setTriggerMoveBottom(false);
  }

  return (
    <ChatWrapper>
      <ChatSection>
        <ChatItemList chatList={chatList} scrollRef={chatScrollRef} onScroll={handleScroll}/>
      </ChatSection>
      {(userInfo)
        ?(<ChatFormSection height={bottomFormHeight}>
            <BottomTextArea maxRow={5} minRow={1} onSubmit={handleSubmit} textAreaStyle={{lineHeight: '20px', color: 'black'}} onHeightChange={handleFormHeightChange}/>
          </ChatFormSection>)
        :null}
      {
        (newMsgExist)
        ?(
          <NewMsgArrived onClick={(e)=>{ moveToBottom(); setNewMsgExist(false);}}formHeight={bottomFormHeight}>새 메시지가 있어요 
            <CloseNewMsgArrived><CloseNewMsgArrivedImg src={downArrowIcon}/></CloseNewMsgArrived>
          </NewMsgArrived>)
        :(null)
      }

      <CenterModal modalVisible={centerModalVisible} setModalVisible={setCenterModalVisible} dataList={centerModalDataList} onCancel={onModalCancel} onComplete={onModalComplete}/>
    </ChatWrapper>
  );
}
const ChatWrapper = styled.div`
  height: 100%;
  background-color:#f7f7f7;
  display: flex;
  flex-flow: column;
`;
const ChatSection = styled.div`
  flex: 1 1 auto;
  height: 100%;
  overflow-y: hidden;
`;
const ChatFormSection = styled.div`
  flex: 0 1 auto;
  min-height: ${(props)=>props.height}px;
  display: flex;
  padding : calc(100vw * (15 / 375)) calc(100vw * (16 / 375));
`;

const NewMsgArrived = styled.div`
  position: fixed;
  bottom : ${(props)=>props.formHeight+ 20}px;
  left: 0;
  right: 0;
  margin: auto;
  width : fit-content;

  background: #FFFFFF;
  box-shadow: 3px 5px 20px #E0E0E0;
  border-radius: calc(100vw * (39 / 375));
  display:flex;
  padding : calc(100vw * (11 / 375)) calc(100vw * (22 / 375))  calc(100vw * (11 / 375)) calc(100vw * (34 / 375));
  align-items: center;
`;
const CloseNewMsgArrived = styled.span`
  width : calc(100vw * (10 / 375)) ;
  height : calc(100vw * (5 / 375)) ;
  display: inline-block;
  margin-left:calc(100vw * (8 / 375));
`;
const CloseNewMsgArrivedImg = styled.img`
`;